import script from "./RemittanceSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./RemittanceSetup.vue?vue&type=script&setup=true&lang=js"

import "./RemittanceSetup.vue?vue&type=style&index=0&id=1f14dbc3&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f14dbc3"]])

export default __exports__